import { Complex, CreateComplex } from 'src/interfaces/complex.interface'
import { coreAPI } from './base.service'
/**
 * get complexes
 * @returns all complexes for realm
 */
export function getAllComplexes(): Promise<Complex[]> {
  const path = `/v1/complexes`
  const req = coreAPI.get(path)
  return req.then((res) => res?.data)
}
/**
 * delete complex
 * @param id complex id
 */
export async function deleteComplex(id: string): Promise<void> {
  const path = `/v1/complexes/${id}`
  await coreAPI.delete(path)
}
/**
 * update complex with new info
 * @param id complex id
 * @param complex updated complex object
 */
export async function updateComplex(id: string, complex: Complex): Promise<Complex | undefined> {
  const path = `/v1/complexes/${id}`
  try {
    const response = await coreAPI.put(path, complex)
    return response?.data
  } catch (error) {
    return undefined
  }
}
/**
 * Creates a new complex in backend
 * @param body name, place and realmId
 * @returns created complex
 */
export async function createNewComplex(body: CreateComplex): Promise<Complex | undefined> {
  const path = `/v1/complexes`
  try {
    const response = await coreAPI.post(path, body)
    return response?.data
  } catch (error) {
    return undefined
  }
}
